import { VideoHTMLAttributes } from "react";
import { BoxProps, uiFactory } from "@/ui";

const EnhancedVideo = uiFactory("video");

export default function AppVideo({
  name,
  options
}: {
  name: string;
  options?: {
    videoProps?: VideoHTMLAttributes<HTMLVideoElement> & BoxProps;
  };
}) {
  const url = new URL(`../../assets/videos/${name}`, import.meta.url).href;
  return <EnhancedVideo src={url} autoPlay loop {...options?.videoProps} />;
}
